/**
 * Get real index of an item (between 0 and items.length)
 * @param i [Int] Index (can be negative or positive)
 * @param l [Int] Total number of the items
 * @returns [Int] Real index
 */
export const getRealIndex = (i, l) => {
	return Math.abs((i < 0 ? i + l : i) % l);
};
